import actions from './actions';

const initState = {
    testData: null,
    fetchingSampleList: false,
    searchingLogs: false,
    searchResult: null,
    searchResultCount: 0,
    searchResultPage: 1,
    searchResultCollection: null,
    loadingMoreLogs: false,
    loadedMoreLogs: null,
    fetchedRole: null,
    fetchingRole: false,
    fetchingRolePermission: false,
    addingRole: false,
    addAuthRoleSuccess: false,
    addRoleMessage: null,
    openRolePermissionDialog: false,
    rolePermission: null,
    payloadCore: null,
    selectedId: null,
    statusData: true,
    authManagementRoleSaved: false,
    editingRoleAuthorization: false,
    csvDownloadLogs: null,
    isDownloadLogs: false,
    fetchingLogsDownloadList: false,
    logsDownloadList: null,
    downloadStatus: null,
    downloadingLogsReport: false,
    fetchingDownloadLogsReport: false,
    fetchedDownloadLogsReport: null,

    // LOOKUPS
    lookupsData: null,
    fetchingLookupsData: false,
    lookupsMessage: null,
    lookupsUpdateMessage: null,
    //
    addingLookups: false,
    lookupsAdded: false,
    //
    deletingLookups: false,
    lookupsDeleted: false,
    //
    updatingLookups: false,
    lookupsUpdated: false,

    // RESPONSE CODE
    fetchingResponseCode: false,
    responseCodes: null,
    loadingMoreResponseCode: false,

    //
    addingResponseCode: false,
    addingResponseCodeSuccess: false,
    addingResponseCodeFailed: false,
    addingResponseCodeFailedMessage: null,
    addingResponseCodeError: false,
    //
    updatingResponseCode: false,
    updatingResponseCodeSuccess: false,
    updatingResponseCodeFailed: false,
    updatingResponseCodeFailedMessage: null,
    updatingResponseCodeError: false,

    //
    deletingResponseCode: false,
    responseCodesDeleted: false,

    // USER MANAGEMENT
    fetchingUsers: false,
    fetchedUsers: null,
    fetchUsersMessage: null,
    fetchingTenants: false,
    fetchedTenants: null,
    settingsMerchants: null,
    settingsFetchingMerchants: false,
    settingsLoadingMoreMerchants: false,
    settingsMerchantHasMore: true,
    settingsLoadingMoreUsers: false,
    settingsUserHasMore: true,
    merchantListNew: null,
    fetchingMerchListNew: false,
    fetchedMerchantSettings: null,
    fetchedMerchantConfigurations: null,
    fetchedProcDetails: null,
    addingUser: false,
    addSuccess: false,
    addMessage: null,
    addingTenant: false,
    addTenantSuccess: false,
    addTenantMessage: null,
    editingUser: false,
    editSuccess: false,
    editMessage: null,
    deletingUser: false,
    deleteSuccess: false,
    // deleteMessage: null,
    merchantUserPasswordReset: false,
    resettingMerchantUserPassword: false,
    filterParams: null,
    rotatingCreds: false,
    rotatingCredsSuccess: false,
    rotatingCredsMessage: null,
    
    generatingSecretKeyIv: false,
    generatingSecretKeyIvSuccess: {},
    generatingSecretKeyIvMessage: null,
    
    fetchingAllWalletGroups: false,
    fetchingAllWalletGroupsSuccess: false,
    fetchedWalletGroups: null,

    fetchingWalletGroupGroups: false,
    fetchingWalletGroupGroupsSuccess: false,
    fetchedWalletGroupGroups: null,

    addingWalletGroup: false,
    addingWalletGroupSuccess: false,
    addingWalletGroupMessage: null,

    editingWalletGroup: false,
    editingWalletGroupSuccess: false,
    editingWalletGroupMessage: null,

    deletingWalletGroup: false,
    deletingWalletGroupSuccess: false,
    deletingWalletGroupMessage: null,

    activatingWalletGroup: false,
    activatingWalletGroupSuccess: false,
    activatingWalletGroupMessage: null,

    deactivatingWalletGroup: false,
    deactivatingWalletGroupSuccess: false,
    deactivatingWalletGroupMessage: null,
    
    fetchingAllBankAccounts: false,
    fetchingAllBankAccountsSuccess: false,
    fetchedBankAccounts: null,
    
    fetchingBankLookups: false,
    fetchingBankLookupsSuccess: false,
    fetchedBankLookups: null,

    addingBankAccount: false,
    addingBankAccountSuccess: false,
    addingBankAccountMessage: null,

    editingBankAccount: false,
    editingBankAccountSuccess: false,
    editingBankAccountMessage: null,

    deletingBankAccount: false,
    deletingBankAccountSuccess: false,
    deletingBankAccountMessage: null,

    activatingBankAccount: false,
    activatingBankAccountSuccess: false,
    activatingBankAccountMessage: null,

    deactivatingBankAccount: false,
    deactivatingBankAccountSuccess: false,
    deactivatingBankAccountMessage: null,
};

export default function transactionsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCHING_SAMPLE:
            return {
                ...state,
                testData: null,
                fetchingTestData: true,
            };
        case actions.FETCHED_SAMPLE:
            return {
                ...state,
                fetchingTestData: false,
                testData: action.data,
            };
        case actions.FETCH_SAMPLE_FAILED:
            return {
                ...state,
                fetchingTestData: false,
                testData: [],
            };
        case actions.SEARCHING_AUDITLOGS:
            return {
                ...state,
                searchingLogs: true,
            };
        case actions.SEARCHED_AUDITLOGS:
            return {
                ...state,
                searchingLogs: false,
                searchResult: action.result,
                searchResultCount: state.searchResultCount > 0 ? state.searchResultCount : action.result.count,
                searchResultPage: action.page,
                filterParams: action.filterParams
                // searchResultCollection: action.collection,
            };
        case actions.SEARCH_AUDITLOGS_FAILED:
            return {
                ...state,
                searchingLogs: false,
                searchResult: null,
            };
        case actions.RESET_AUDITLOGS:
            return {
                ...state,
                searchingLogs: false,
                loadingMoreLogs: false,
                searchResult: null,
                loadedMoreLogs: null,
                searchResultCount: 0,
                searchResultPage: 1,
                searchResultCollection: null,
            }

        // DOWNLOAD AUDIT LOGS
        case actions.DOWNLOADED_AUDIT_LOGS:
            return {
                ...state,
                csvDownloadLogs: action.payload,
                isDownloadLogs: false,
                // previousDownloads: false
            };
        case actions.DOWNLOADING_AUDIT_LOGS:
            return {
                ...state,
                isDownloadLogs: true,
            };
        case actions.CLEAR_DOWNLOAD_AUDIT_LOGS:
            return {
                ...state,
                csvDownloadLogs: null,
                isDownloadLogs: false,
            };
        case actions.DOWNLOAD_FAILED_AUDIT_LOGS:
            return {
                ...state,
                csvDownloadLogs: null,
                isDownloadLogs: false,
            };

        case actions.FETCHING_LOGS_DOWNLOAD_LIST:
            return {
                ...state,
                fetchingLogsDownloadList: true,
            };
        case actions.FETCHED_LOGS_DOWNLOAD_LIST:
            return {
                ...state,
                logsDownloadList: action.payload,
                fetchingLogsDownloadList: false,
            };
        case actions.DOWNLOAD_STATUS:
            return {
                ...state,
                downloadStatus: action.payload,
            };
        // FETCH DOWNLOADED LOGS REPORT
        case actions.FETCHING_DOWNLOAD_LOGS_REPORT:
            return {
                ...state,
                fetchingDownloadReport: true,
            };

        case actions.FETCHED_DOWNLOAD_LOGS_REPORT:
            return {
                ...state,
                downloadingLogsReport: false,
                fetchingDownloadLogsReport: false,
                fetchedDownloadLogsReport: action.data,
            };

        case actions.FETCH_DOWNLOAD_LOGS_REPORT_FAILED:
            return {
                ...state,
                fetchingDownloadLogsReport: false,
            };

        case actions.FETCH_DOWNLOAD_LOGS_REPORT_RESET:
            return {
                ...state,
                downloadingLogsReport: false,
                fetchingDownloadLogsReport: false,
                fetchedDownloadLogsReport: null,
            };
        case actions.RESET_DOWNLOAD_LOGS_REPORT:
            return {
                ...state,
                fetchingDownloadLogsReport: false,
                fetchedDownloadLogsReport: null,
            };
        // FETCH ROLE
        case actions.FETCHING_ROLE:
            return {
                ...state,
                fetchedRole: null,
                fetchingRole: true,
            };
        case actions.FETCHED_ROLE:
            return {
                ...state,
                fetchingRole: false,
                fetchedRole: action.data,
            };
        case actions.FETCH_ROLE_FAILED:
            return {
                ...state,
                fetchingRole: false,
                fetchedRole: null,
            };

        // ADD_AUTH_ROLE
        case actions.AUTH_ROLES_ADDED:
            return {
                ...state,
                addingRole: false,
                addAuthRoleSuccess: true,
                fetchedRole: action.payload,
            };
        case actions.ADDING_AUTH_ROLES:
            return {
                ...state,
                addingRole: true,
            };
        case actions.ADD_AUTH_ROLES_FAILED:
            return {
                ...state,
                addingRole: false,
                addRoleMessage: action.payload,
            };
        case actions.RESET_ADD_AUTH_ROLES:
            return {
                ...state,
                addAuthRoleSuccess: false,
                addRoleMessage: false,
                loadingAuthManagementRole: false
            };

        // FETCH ROLE PERMISSION
        case actions.OPEN_PERMISSION_DIALOG:
            return {
                ...state,
                openRolePermissionDialog: !state.openRolePermissionDialog,
            };
        case actions.FETCHING_PERMISSION:
            return {
                ...state,
                fetchingRolePermission: true,
            };
        case actions.ROLE_PERMISSION_FETCHED:
            return {
                ...state,
                rolePermission: action.payload,
                payloadCore: action.payloadCore,
                selectedId: action.selectedId,
                fetchingRolePermission: false
            };
        case actions.RESET_PERMISSION_DATA:
            return {
                ...state,
                rolePermission: null,
                selectedId: null,
                payloadCore: null,
                fetchingRolePermission: false
            };

        // SAVE EDIT ROLE
        case actions.AUTH_ROLE_MANAGEMENT_SAVED:
            return {
                ...state,
                authManagementRoleSaved: true,
                editingRoleAuthorization: false,
            };
        case actions.SAVING_AUTH_ROLE_MANAGEMENT:
            return {
                ...state,
                editingRoleAuthorization: true,
            };
        case actions.SAVE_AUTH_ROLE_MANAGEMENT_FAILED:
            return {
                ...state,
                authManagementRoleSaved: false,
                editingRoleAuthorization: false,
            };
        case actions.RESET_SAVE_AUTH_ROLE_MANAGEMENT:
            return {
                ...state,
                authManagementRoleSaved: false,
                editingRoleAuthorization: false,
            };
        case actions.FETCHING_LOOKUPS:
            return {
                ...state,
                fetchingLookupsData: true,
                lookupsData: null
            };
        case actions.FETCHED_LOOKUPS:
            return {
                ...state,
                lookupsData: action.result,
                fetchingLookupsData: false,
            };
        case actions.FETCHING_USER_MANAGEMENT_LOOKUPS:
            return {
                ...state,
                fetchingUserManagementLookupsData: true,
                userManagementLookupsData: null
            };
        case actions.FETCHED_USER_MANAGEMENT_LOOKUPS:
            return {
                ...state,
                userManagementLookupsData: action.result,
                fetchingUserManagementLookupsData: false,
            };
        case actions.FETCHING_RESPONSE_CODE_LOOKUPS:
            return {
                ...state,
                fetchingResponseCodeLookupsData: true,
                responseCodeLookupsData: null
            };
        case actions.FETCHED_RESPONSE_CODE_LOOKUPS:
            return {
                ...state,
                responseCodeLookupsData: action.result,
                fetchingResponseCodeLookupsData: false,
            };
        case actions.ADDING_LOOKUPS:
            return {
                ...state,
                addingLookups: true,
            };
        case actions.ADDED_LOOKUPS:
            return {
                ...state,
                lookupsData: action.result,
                addingLookups: false,
                lookupsAdded: true,
                lookupsMessage: null
            };
        case actions.ADD_LOOKUPS_FAILED:
            return {
                ...state,
                lookupsMessage: action.payload,
                lookupsAdded: false,
            };
        case actions.RESET_ADD_LOOKUPS:
            return {
                ...state,
                // lookupsData: null,
                lookupsMessage: null,
                addingLookups: false,
                lookupsAdded: false,
            };
        case actions.DELETING_LOOKUPS:
            return {
                ...state,
                deletingLookups: true,
            };
        case actions.DELETED_LOOKUPS:
            return {
                ...state,
                lookupsData: action.result,
                lookupsDeleted: true,
                deletingLookups: false,
            };
        case actions.RESET_DELETE_LOOKUPS:
            return {
                ...state,
                deletingLookups: false,
                // lookupsData: null,
                lookupsDeleted: false,
            };
        case actions.UPDATING_LOOKUPS:
            return {
                ...state,
                updatingLookups: true,
            };
        case actions.UPDATED_LOOKUPS:
            return {
                ...state,
                lookupsData: action.result,
                lookupsUpdated: true,
                updatingLookups: false,
                lookupsUpdateMessage: null
            };
        case actions.UPDATE_LOOKUPS_FAILED:
            return {
                ...state,
                lookupsUpdateMessage: action.payload,
                lookupsUpdated: false,
            };
        case actions.RESET_UPDATE_LOOKUPS:
            return {
                ...state,
                updatingLookups: false,
                // lookupsData: null,
                lookupsUpdateMessage: null,
                lookupsUpdated: false,
            };
        case actions.FETCHING_RESPONSE_CODE:
            return {
                ...state,
                fetchingResponseCode: true,
                responseCodes: null
            };
        case actions.LOADING_MORE_RESPONSE_CODE:
            return {
                ...state,
                loadingMoreResponseCode: true,
            };
        case actions.FETCHED_RESPONSE_CODE:
            return {
                ...state,
                fetchingResponseCode: false,
                loadingMoreResponseCode: false,
                responseCodes: action.result,
            };
        case actions.FETCH_RESPONSE_CODE_FAILED:
            return {
                ...state,
                fetchingResponseCode: false,
                responseCodes: null,
                // searchCount: 0,
            };

        case actions.ADDING_RESPONSE_CODE:
            return {
                ...state,
                addingResponseCode: true,
                addingResponseCodeFailedMessage: null,
            };
        case actions.ADDED_RESPONSE_CODE:
            return {
                ...state,
                addingResponseCode: false,
                addingResponseCodeSuccess: true,
                responseCodes: action.result,
            };
        case actions.ADD_RESPONSE_CODE_FAILED:
            return {
                ...state,
                addingResponseCode: false,
                addingResponseCodeFailed: true,
                addingResponseCodeFailedMessage: action.payload,
            };
        case actions.ADD_RESPONSE_CODE_ERROR:
            return {
                ...state,
                addingResponseCode: false,
            };
        case actions.RESET_ADD_RESPONSE_CODE:
            return {
                ...state,
                addingResponseCodeSuccess: false,
                addingResponseCodeFailed: false,
                addingResponseCodeError: false,
            };
        case actions.RESET_ADD_RESPONSE_CODE_MESSAGE:
            return {
                ...state,
                addingResponseCodeFailedMessage: null,
            };
        //
        case actions.UPDATING_RESPONSE_CODE:
            return {
                ...state,
                updatingResponseCode: true,
                updatingResponseCodeFailedMessage: null,
            };
        case actions.UPDATED_RESPONSE_CODE:
            return {
                ...state,
                updatingResponseCode: false,
                updatingResponseCodeSuccess: true,
                responseCodes: action.result,
            };
        case actions.UPDATE_RESPONSE_CODE_FAILED:
            return {
                ...state,
                updatingResponseCode: false,
                updatingResponseCodeFailed: true,
                updatingResponseCodeFailedMessage: action.payload,
            };
        case actions.UPDATE_RESPONSE_CODE_ERROR:
            return {
                ...state,
                updatingResponseCode: false,
            };
        case actions.RESET_UPDATE_RESPONSE_CODE:
            return {
                ...state,
                updatingResponseCodeSuccess: false,
                updatingResponseCodeFailed: false,
                updatingResponseCodeError: false,
            };
        case actions.RESET_UPDATE_RESPONSE_CODE_MESSAGE:
            return {
                ...state,
                updatingResponseCodeFailedMessage: null,
            };
        //
        case actions.DELETING_RESPONSE_CODE:
            return {
                ...state,
                deletingResponseCode: true,
            };
        case actions.DELETED_RESPONSE_CODE:
            return {
                ...state,
                deletingResponseCode: false,
                responseCodesDeleted: true,
                responseCodes: action.result,
            };
        case actions.DELETE_RESPONSE_CODE_FAILED:
            return {
                ...state,
                deletingResponseCode: false,
            };
        case actions.DELETE_RESPONSE_CODE_ERROR:
            return {
                ...state,
                deletingResponseCode: false,
            };
        case actions.RESET_DELETE_RESPONSE_CODE:
            return {
                ...state,
                responseCodesDeleted: false,
            };

        case actions.FETCHING_MERCHANT_LIST_SETTINGS:
            return {
                ...state,
                settingsMerchants: action.append ? state.settingsMerchants : null,
                fetchedMerchantSettings: null,
                authManagementRole: null,
                settingsFetchingMerchants: action.append ? state.settingsFetchingMerchants : true,
                settingsLoadingMoreMerchants: action.append ? true : false,
                settingsMerchantHasMore: action.append ? state.settingsMerchantHasMore : true,
                settingsFetchingMerchants: action.append ? state.settingsFetchingMerchants : true,
                settingsLoadingMoreMerchants: action.append ? true : false,
                settingsMerchantHasMore: action.append ? state.settingsMerchantHasMore : true,
                fetchedMerchantConfigurations: null,
                fetchedProcDetails: null
            };
        case actions.FETCHED_MERCHANT_LIST_SETTINGS:
            return {
                ...state,
                settingsFetchingMerchants: false,
                settingsLoadingMoreMerchants: false,
                settingsMerchantHasMore: action.hasMore !== undefined ? action.hasMore : state.settingsMerchantHasMore,
                settingsMerchants: action.append && state.settingsMerchants && state.settingsMerchants.result
                    ? {
                        ...state.settingsMerchants,
                        ...action.payload,
                        result: [
                            ...state.settingsMerchants.result,
                            ...(action.payload.result || []),
                        ],
                    }
                    : action.payload,
            };
        case actions.FETCH_MERCHANT_LIST_SETTINGS_FAILED:
            return {
                ...state,
                settingsFetchingMerchants: false,
                settingsLoadingMoreMerchants: false,
            };
        case actions.SETTINGS_SEARCHING_MERCHANTS:
            return {
                ...state,
                settingsFetchingMerchants: true,
                settingsMerchants: null,
                fetchedMerchantSettings: null,
                fetchedMerchantConfigurations: null,
                fetchedProcDetails: null
            };
        case actions.SETTINGS_SEARCHED_MERCHANTS:
            return {
                ...state,
                settingsMerchants: action.payload,
                settingsFetchingMerchants: false
            };
        case actions.SETTINGS_SEARCHING_MERCHANTS_FAILED:
            return {
                ...state,
                settingsFetchingMerchants: false,
                settingsMerchants: action.data
            };
        case actions.FETCHING_USERS:
            return {
                ...state,
                fetchedUsers: action.append ? state.fetchedUsers : null,
                fetchingUsers: true,
                settingsLoadingMoreUsers: action.append ? true : false,
                fetchUsersMessage: null,
            };
        case actions.FETCHED_USERS:
            return {
                ...state,
                fetchingUsers: false,
                settingsLoadingMoreUsers: false,
                settingsUserHasMore: action.hasMore !== undefined ? action.hasMore : state.settingsUserHasMore,
                fetchedUsers: action.append && state.fetchedUsers && Array.isArray(state.fetchedUsers)
                    ? [...state.fetchedUsers, ...(action.data || [])]
                    : action.data,
            };
        case actions.FETCH_USERS_FAILED:
            return {
                ...state,
                fetchingUsers: false,
                settingsLoadingMoreUsers: false,
                fetchUsersMessage: action.message
            };
        case actions.FETCHING_TENANT:
            return {
                ...state,
                fetchedTenants: null,
                fetchingTenants: true,
            };
        case actions.FETCHED_TENANT:
            return {
                ...state,
                fetchingTenants: false,
                fetchedTenants: action.data
            };
        case actions.FETCH_TENANT_FAILED:
            return {
                ...state,
                fetchingTenants: false
            };

        case actions.ADDING_USER:
            return {
                ...state,
                addingUser: true
            };
        case actions.ADDED_USER:
            return {
                ...state,
                addingUser: false,
                addMessage: null,
                addSuccess: true,
                fetchedUsers: [
                    ...state.fetchedUsers,
                    {
                        accountName: action.data.account_name,
                        email: action.data.email,
                        first_name: action.data.first_name,
                        id: action.data.Id,
                        last_name: action.data.last_name,
                        merchant_name: action.data.merchant_name,
                        username: action.data.username,
                        label: action.data.label,
                        auth_role_id: action.data.role_id,
                        status: action.data.status,
                        passwordExpiration: action.data.passwordExpiration,
                        tenant_name: action.data.tenant_name,
                        dgate_mid: action.data.dgate_mid,
                        dgate_mkey: action.data.dgate_mkey
                    }
                ],
            };
        case actions.ADD_USER_FAILED:
            return {
                ...state,
                addingUser: false,
                addMessage: action.message
            };
        case actions.ADD_TENANT_FAILED:
            return {
                ...state,
                addingTenant: false,
                addTenantMessage: action.message === 'Invalid Request.' ? 'Username already exists.' : action.message
            };
        case actions.RESET_ADD_USER:
            return {
                ...state,
                addingUser: false,
                addSuccess: false,
                addMessage: null,
            };
        case actions.ADDING_TENANT:
            return {
                ...state,
                addingTenant: true
            };
        case actions.ADDED_TENANT:
            return {
                ...state,
                addingTenant: false,
                addTenantMessage: null,
                addTenantSuccess: true,
                fetchedUsers: [
                    ...state.fetchedUsers,
                    {
                        accountName: action.data.accountName,
                        email: action.data.email,
                        first_name: action.data.first_name,
                        id: action.data.Id,
                        last_name: action.data.last_name,
                        merchant_name: action.data.merchant_name,
                        username: action.data.username,
                        label: action.data.label,
                        auth_role_id: action.data.roleId,
                        tenant_use_case: action.data.tenant_use_case,
                        tenant_notif_level: action.data.tenant_notif_level,
                        notification_url: action.data.notification_url,
                        wallet_group: action.data.wallet_group,
                        utilize_portal: action.data.utilize_portal,
                        allow_trx_below_threshold: action.data.allow_trx_below_threshold,
                        is_cust_kyc_one_required: action.data.is_cust_kyc_one_required,
                        pass_on_fee: action.data.isPassOnFee,
                        status: action.data.status,
                        passwordExpiration: action.data.passwordExpiration,
                        is_utilize_email: action.data.is_utilize_email,
                        enable_trx_verification: action.data.enable_trx_verification,
                        is_bypass_otp: action.data.is_bypass_otp,
                        can_update_qr_amount: action.data.can_update_qr_amount,
                        test_tenant: action.data.test_tenant,
                        dgate_mid: action.data.dgate_mid,
                        dgate_mkey: action.data.dgate_mkey,
                        account_number_format: action.data.account_number_format,
                        enable_corp_withdraw: action.data.enable_corp_withdraw,
                    }
                ],
            };
        case actions.RESET_ADD_TENANT:
            return {
                ...state,
                addingTenant: false,
                addTenantSuccess: false,
                addTenantMessage: null,
            };
        case actions.EDITING_USER:
            return {
                ...state,
                editingUser: true
            };
        case actions.EDITED_USER:
            const fetchedUsers = state.fetchedUsers;
            const updatedUsers = [];
            for (let i = 0; i < fetchedUsers.length; i++) {
                const item = fetchedUsers[i];
                if (action.user.id === item.id) {
                    fetchedUsers[i].account_name = `${action.user.first_name} ${action.user.last_name}`;
                    fetchedUsers[i].first_name = action.user.first_name;
                    fetchedUsers[i].last_name = action.user.last_name;
                    fetchedUsers[i].email = action.user.email;
                    fetchedUsers[i].label = action.user.label;
                    fetchedUsers[i].tenant_use_case = action.user.tenant_use_case;
                    fetchedUsers[i].tenant_notif_level = action.user.tenant_notif_level;
                    fetchedUsers[i].notification_url = action.user.notification_url;
                    fetchedUsers[i].wallet_group = action.user.wallet_group;
                    fetchedUsers[i].utilize_portal = action.user.utilize_portal;
                    fetchedUsers[i].allow_trx_below_threshold = action.user.allow_trx_below_threshold;
                    fetchedUsers[i].is_cust_kyc_one_required = action.user.is_cust_kyc_one_required;
                    fetchedUsers[i].pass_on_fee = action.user.pass_on_fee;
                    fetchedUsers[i].status = action.user.status;
                    fetchedUsers[i].passwordExpiration = action.user.passwordExpiration;
                    fetchedUsers[i].is_utilize_email = action.user.is_utilize_email;
                    fetchedUsers[i].enable_trx_verification = action.user.enable_trx_verification;
                    fetchedUsers[i].is_bypass_otp = action.user.is_bypass_otp;
                    fetchedUsers[i].can_update_qr_amount = action.user.can_update_qr_amount;
                    fetchedUsers[i].test_tenant = action.user.test_tenant;
                    fetchedUsers[i].dgate_mid = action.user.dgate_mid;
                    fetchedUsers[i].dgate_mkey = action.user.dgate_mkey;
                    fetchedUsers[i].account_number_format = action.user.account_number_format;
                    fetchedUsers[i].enable_corp_withdraw = action.user.enable_corp_withdraw;
                }
                updatedUsers.push(fetchedUsers[i]);
            }
            return {
                ...state,
                editingUser: false,
                editSuccess: true,
                editMessage: null,
                fetchedUsers: updatedUsers,
            };
        case actions.EDIT_USER_FAILED:
            return {
                ...state,
                editingUser: false,
                editMessage: action.message,
                editSuccess: false,
            };
        case actions.RESET_EDIT_USER:
            return {
                ...state,
                editingUser: false,
                editSuccess: false,
                editMessage: null
            };
        case actions.DELETING_USER:
            return {
                ...state,
                deletingUser: true
            };
        case actions.DELETED_USER:
            return {
                ...state,
                deletingUser: false,
                deleteSuccess: true,
                // deleteMessage: action.message,
                fetchedUsers: action.users,
            };
        case actions.DELETE_USER_FAILED:
            return {
                ...state,
                deletingUser: false,
                // deleteMessage: action.message
            };
        case actions.RESET_DELETE_USER:
            return {
                ...state,
                deletingUser: false,
                deleteSuccess: false,
                // deleteMessage: null
            };
        case actions.MERCHANT_USER_PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                merchantUserPasswordReset: true,
                resettingMerchantUserPassword: false
            };
        case actions.RESET_MERCHANT_USER_PASSWORD_RESET:
            return {
                ...state,
                merchantUserPasswordReset: false,
            };

        case actions.RESETTING_MERCHANT_USER_PASSWORD:
            return {
                ...state,
                resettingMerchantUserPassword: true,
            };

        case actions.ROTATING_CREDENTIALS:
            return {
                ...state,
                rotatingCreds: true
            };
        case actions.ROTATED_CREDENTIALS:
            const fetchedRotatedCreds = state.fetchedUsers;
            const updatedRotatedCreds = [];
            for (let i = 0; i < fetchedRotatedCreds.length; i++) {
                const item = fetchedRotatedCreds[i];
                if (action.user.id === item.id) {
                    fetchedRotatedCreds[i].account_name = `${action.user.first_name} ${action.user.last_name}`;
                    fetchedRotatedCreds[i].first_name = action.user.first_name;
                    fetchedRotatedCreds[i].last_name = action.user.last_name;
                    fetchedRotatedCreds[i].email = action.user.email;
                    fetchedRotatedCreds[i].label = action.user.label;
                    fetchedRotatedCreds[i].tenant_use_case = action.user.tenant_use_case;
                    fetchedRotatedCreds[i].tenant_notif_level = action.user.tenant_notif_level;
                    fetchedRotatedCreds[i].notification_url = action.user.notification_url;
                    fetchedRotatedCreds[i].utilize_portal = action.user.utilize_portal;
                    fetchedRotatedCreds[i].allow_trx_below_threshold = action.user.allow_trx_below_threshold;
                    fetchedRotatedCreds[i].is_cust_kyc_one_required = action.user.is_cust_kyc_one_required;
                    fetchedRotatedCreds[i].pass_on_fee = action.user.pass_on_fee;
                    fetchedRotatedCreds[i].status = action.user.status;
                    fetchedRotatedCreds[i].passwordExpiration = action.user.passwordExpiration;
                    fetchedRotatedCreds[i].is_utilize_email = action.user.is_utilize_email;
                    fetchedRotatedCreds[i].enable_trx_verification = action.user.enable_trx_verification;
                    fetchedRotatedCreds[i].is_bypass_otp = action.user.is_bypass_otp;
                    fetchedRotatedCreds[i].can_update_qr_amount = action.user.can_update_qr_amount;
                    fetchedRotatedCreds[i].test_tenant = action.user.test_tenant;
                    fetchedRotatedCreds[i].dgate_mid = action.user.dgate_mid;
                    fetchedRotatedCreds[i].dgate_mkey = action.user.dgate_mkey;
                    fetchedRotatedCreds[i].account_number_format = action.user.account_number_format;
                    fetchedRotatedCreds[i].username = action.user.username;
                    fetchedRotatedCreds[i].secret_key = action.user.secret_key;
                    fetchedRotatedCreds[i].secret_iv = action.user.secret_iv;
                }
                updatedRotatedCreds.push(fetchedRotatedCreds[i]);
            }
            return {
                ...state,
                rotatingCreds: false,
                rotatingCredsSuccess: true,
                rotatingCredsMessage: null,
                fetchedUsers: updatedRotatedCreds,
            };
        case actions.ROTATE_CREDENTIALS_FAILED:
            return {
                ...state,
                rotatingCreds: false,
                rotatingCredsMessage: action.message,
                rotatingCredsSuccess: false,
            };
        case actions.RESET_ROTATE_CREDENTIALS:
            return {
                ...state,
                rotatingCreds: false,
                rotatingCredsSuccess: false,
                rotatingCredsMessage: null
            };
        case actions.GENERATING_SECRET_KEY_IV:
            return {
                ...state,
                generatingSecretKeyIv: true
            };
        case actions.GENERATED_SECRET_KEY_IV:
            return {
                ...state,
                generatingSecretKeyIv: false,
                generatingSecretKeyIvSuccess: {
                    ...state.generatingSecretKeyIvSuccess,
                    [action.payload.tenant_link]: true
                },
                generatingSecretKeyIvMessage: null,
            };
        case actions.GENERATE_SECRET_KEY_IV_FAILED:
            return {
                ...state,
                generatingSecretKeyIv: false,
                generatingSecretKeyIvSuccess: {
                    ...state.generatingSecretKeyIvSuccess,
                    [action.payload.tenant_link]: false
                },
                generatingSecretKeyIvMessage: action.message,
            };
        case actions.RESET_GENERATE_SECRET_KEY_IV:
            return {
                ...state,
                generatingSecretKeyIv: false,
                generatingSecretKeyIvSuccess: false,
                generatingSecretKeyIvMessage: null,
            };

        case actions.FETCHING_ALL_WALLET_GROUPS:
            return {
                ...state,
                fetchingAllWalletGroups: true
            };
        case actions.FETCHED_ALL_WALLET_GROUPS:
            return {
                ...state,
                fetchingAllWalletGroups: false,
                fetchingAllWalletGroupsSuccess: true,
                fetchedWalletGroups: action.payload
            };
        case actions.FETCH_ALL_WALLET_GROUPS_FAILED:
            return {
                ...state,
                fetchingAllWalletGroups: false,
                fetchingAllWalletGroupsSuccess: false
            };

        case actions.FETCHING_WALLET_GROUP_GROUPS:
            return {
                ...state,
                fetchingWalletGroupGroups: true,
            };
        case actions.FETCHED_WALLET_GROUP_GROUPS:
            return {
                ...state,
                fetchingWalletGroupGroups: false,
                fetchingWalletGroupGroupsSuccess: true,
                fetchedWalletGroupGroups: action.payload
            };
        case actions.FETCH_WALLET_GROUP_GROUPS_FAILED:
            return {
                ...state,
                fetchingWalletGroupGroups: false,
                fetchingWalletGroupGroupsSuccess: false
            };

        case actions.ADDING_WALLET_GROUP:
            return {
                ...state,
                addingWalletGroup: true
            };
        case actions.ADDED_WALLET_GROUP:
            return {
                ...state,
                addingWalletGroup: false,
                addingWalletGroupSuccess: true,
                addingWalletGroupMessage: action.message,
                fetchedWalletGroups: [
                    ...state.fetchedWalletGroups,
                    {
                        _id: action.payload._id,
                        label: action.payload.label,
                        description: action.payload.description,
                        bank_account_id: action.payload.bank_account_id,
                        status: action.payload.status,
                        group_name: action.payload.group_name,
                    }
                ]
            };
        case actions.ADD_WALLET_GROUP_FAILED:
            return {
                ...state,
                addingWalletGroup: false,
                addingWalletGroupSuccess: false,
                addingWalletGroupMessage: action.message
            };
        case actions.RESET_ADD_WALLET_GROUP:
            return {
                ...state,
                addingWalletGroup: false,
                addingWalletGroupSuccess: false,
                addingWalletGroupMessage: null
            };

        case actions.EDITING_WALLET_GROUP:
            return{
                ...state,
                editingWalletGroup: true
            };
        case actions.EDITED_WALLET_GROUP: {
            const fetchedWalletGroups = state.fetchedWalletGroups;
            const updatedWalletGroup = [];
            for (let i = 0; i < fetchedWalletGroups.length; i++) {
                const item = fetchedWalletGroups[i];
                if (action.payload._id === item._id) {
                    fetchedWalletGroups[i].group_name = action.payload.group_name;
                    fetchedWalletGroups[i].description = action.payload.description;
                    fetchedWalletGroups[i].bank_account_id = action.payload.bank_account_id;
                }
                updatedWalletGroup.push(fetchedWalletGroups[i]);
            }

            return{
                ...state,
                editingWalletGroup: false,
                editingWalletGroupSuccess: true,
                editingWalletGroupMessage: action.message,
                fetchedWalletGroups: updatedWalletGroup
            };
        }
        case actions.EDIT_WALLET_GROUP_FAILED:
            return{
                ...state,
                editingWalletGroup: false,
                editingWalletGroupSuccess: false,
                editingWalletGroupMessage: action.message
            };
        case actions.RESET_EDIT_WALLET_GROUP:
            return{
                ...state,
                editingWalletGroup: false,
                editingWalletGroupSuccess: false,
                editingWalletGroupMessage: null
            };

        case actions.DELETING_WALLET_GROUP:
            return{
                ...state,
                deletingWalletGroup: true
            };
        case actions.DELETED_WALLET_GROUP: {
            const fetchedWalletGroups = state.fetchedWalletGroups;
            const updatedWalletGroup = [];
            for (let i = 0; i < fetchedWalletGroups.length; i++) {
                const item = fetchedWalletGroups[i];
                if (action.payload._id === item._id) {
                    fetchedWalletGroups[i].status = action.payload.status;
                }
                updatedWalletGroup.push(fetchedWalletGroups[i]);
            }

            return{
                ...state,
                deletingWalletGroup: false,
                deletingWalletGroupSuccess: true,
                deletingWalletGroupMessage: action.message,
                fetchedWalletGroups: updatedWalletGroup
            };
        }
        case actions.DELETE_WALLET_GROUP_FAILED:
            return{
                ...state,
                deletingWalletGroup: false,
                deletingWalletGroupSuccess: false,
                deletingWalletGroupMessage: action.message
            };
        case actions.RESET_DELETE_WALLET_GROUP:
            return{
                ...state,
                deletingWalletGroup: false,
                deletingWalletGroupSuccess: false,
                deletingWalletGroupMessage: null
            };

        case actions.ACTIVATING_WALLET_GROUP:
            return{
                ...state,
                activatingWalletGroup: true
            };
        case actions.ACTIVATED_WALLET_GROUP: {
            const fetchedWalletGroups = state.fetchedWalletGroups;
            const updatedWalletGroup = [];
            for (let i = 0; i < fetchedWalletGroups.length; i++) {
                const item = fetchedWalletGroups[i];
                if (action.payload._id === item._id) {
                    fetchedWalletGroups[i].status = action.payload.status;
                }
                updatedWalletGroup.push(fetchedWalletGroups[i]);
            }

            return{
                ...state,
                activatingWalletGroup: false,
                activatingWalletGroupSuccess: true,
                activatingWalletGroupMessage: action.message,
                fetchedWalletGroups: updatedWalletGroup
            };
        }
        case actions.ACTIVATE_WALLET_GROUP_FAILED:
            return{
                ...state,
                activatingWalletGroup: false,
                activatingWalletGroupSuccess: false,
                activatingWalletGroupMessage: action.message
            };
        case actions.RESET_ACTIVATE_WALLET_GROUP:
            return{
                ...state,
                activatingWalletGroup: false,
                activatingWalletGroupSuccess: false,
                activatingWalletGroupMessage: null
            };

        case actions.DEACTIVATING_WALLET_GROUP:
            return{
                ...state,
                deactivatingWalletGroup: true
            };
        case actions.DEACTIVATED_WALLET_GROUP: {
            const fetchedWalletGroups = state.fetchedWalletGroups;
            const updatedWalletGroup = [];
            for (let i = 0; i < fetchedWalletGroups.length; i++) {
                const item = fetchedWalletGroups[i];
                if (action.payload._id === item._id) {
                    fetchedWalletGroups[i].status = action.payload.status;
                }
                updatedWalletGroup.push(fetchedWalletGroups[i]);
            }

            return{
                ...state,
                deactivatingWalletGroup: false,
                deactivatingWalletGroupSuccess: true,
                deactivatingWalletGroupMessage: action.message,
                fetchedWalletGroups: updatedWalletGroup
            };
        }
        case actions.DEACTIVATE_WALLET_GROUP_FAILED:
            return{
                ...state,
                deactivatingWalletGroup: false,
                deactivatingWalletGroupSuccess: false,
                deactivatingWalletGroupMessage: action.message
            };
        case actions.RESET_DEACTIVATE_WALLET_GROUP:
            return{
                ...state,
                deactivatingWalletGroup: false,
                deactivatingWalletGroupSuccess: false,
                deactivatingWalletGroupMessage: null
            };

        case actions.FETCHING_ALL_BANK_ACCOUNTS:
            return {
                ...state,
                fetchingAllBankAccounts: true
            };
        case actions.FETCHED_ALL_BANK_ACCOUNTS:
            return {
                ...state,
                fetchingAllBankAccounts: false,
                fetchingAllBankAccountsSuccess: true,
                fetchedBankAccounts: action.payload
            };
        case actions.FETCH_ALL_BANK_ACCOUNTS_FAILED:
            return {
                ...state,
                fetchingAllBankAccounts: false,
                fetchingAllBankAccountsSuccess: false
            };

        case actions.FETCHING_BANK_LOOKUPS:
            return {
                ...state,
                fetchingBankLookups: true
            };
        case actions.FETCHED_BANK_LOOKUPS:
            return {
                ...state,
                fetchingBankLookups: false,
                fetchingBankLookupsSuccess: true,
                fetchedBankLookups: action.payload
            };
        case actions.FETCH_BANK_LOOKUPS_FAILED:
            return {
                ...state,
                fetchingBankLookups: false,
                fetchingBankLookupsSuccess: false
            };

        case actions.ADDING_BANK_ACCOUNT:
            return {
                ...state,
                addingBankAccount: true
            };
        case actions.ADDED_BANK_ACCOUNT:
            return {
                ...state,
                addingBankAccount: false,
                addingBankAccountSuccess: true,
                addingBankAccountMessage: action.message,
                fetchedBankAccounts: [
                    ...state.fetchedBankAccounts,
                    {
                        _id: action.payload._id,
                        bank_id: action.payload.bank_id,
                        name: action.payload.name,
                        bank_account_no: action.payload.bank_account_no,
                        currency: action.payload.currency,
                        status: action.payload.status
                    }
                ]
            };
        case actions.RESET_ADD_BANK_ACCOUNT:
            return {
                ...state,
                addingBankAccount: false,
                addingBankAccountSuccess: false,
                addingBankAccountMessage: null,
            };
        case actions.ADD_BANK_ACCOUNT_FAILED:
            return {
                ...state,
                addingBankAccount: false,
                addingBankAccountSuccess: false,
                addingBankAccountMessage: action.message,
            };

        case actions.EDITING_BANK_ACCOUNT:
            return {
                ...state,
                editingBankAccount: true
            };
        case actions.EDITED_BANK_ACCOUNT: {
            const fetchedBankAccounts = state.fetchedBankAccounts;
            const updatedBankAccount = [];
            for (let i = 0; i < fetchedBankAccounts.length; i++) {
                const item = fetchedBankAccounts[i];
                if (action.payload._id === item._id) {
                    fetchedBankAccounts[i].name = action.payload.name;
                }
                updatedBankAccount.push(fetchedBankAccounts[i]);
            }
            return {
                ...state,
                editingBankAccount: false,
                editingBankAccountSuccess: true,
                editingBankAccountMessage: action.message,
                fetchedBankAccounts: updatedBankAccount
            };
        }
        case actions.RESET_EDIT_BANK_ACCOUNT:
            return {
                ...state,
                editingBankAccount: false,
                editingBankAccountSuccess: false,
                editingBankAccountMessage: null
            };
        case actions.EDIT_BANK_ACCOUNT_FAILED:
            return {
                ...state,
                editingBankAccount: false,
                editingBankAccountSuccess: false,
                editingBankAccountMessage: action.message
            };

        case actions.DELETING_BANK_ACCOUNT:
            return {
                ...state,
                deletingBankAccount: true
            };
        case actions.DELETED_BANK_ACCOUNT: {
            const fetchedBankAccounts = state.fetchedBankAccounts;
            const updatedBankAccount = [];
            for (let i = 0; i < fetchedBankAccounts.length; i++) {
                const item = fetchedBankAccounts[i];
                if (action.payload._id === item._id) {
                    fetchedBankAccounts[i].status = action.payload.status;
                }
                updatedBankAccount.push(fetchedBankAccounts[i]);
            }
            return {
                ...state,
                deletingBankAccount: false,
                deletingBankAccountSuccess: true,
                deletingBankAccountMessage: action.message,
                fetchedBankAccounts: updatedBankAccount
            };
        }
        case actions.DELETE_BANK_ACCOUNT_FAILED:
            return {
                ...state,
                deletingBankAccount: false,
                deletingBankAccountSuccess: false,
                deletingBankAccountMessage: action.message
            };
        case actions.RESET_DELETE_BANK_ACCOUNT:
            return {
                ...state,
                deletingBankAccount: false,
                deletingBankAccountSuccess: false,
                deletingBankAccountMessage: null,
            };

        case actions.ACTIVATING_BANK_ACCOUNT:
            return {
                ...state,
                activatingBankAccount: true
            };
        case actions.ACTIVATED_BANK_ACCOUNT: {
            const fetchedBankAccounts = state.fetchedBankAccounts;
            const updatedBankAccount = [];
            for (let i = 0; i < fetchedBankAccounts.length; i++) {
                const item = fetchedBankAccounts[i];
                if (action.payload._id === item._id) {
                    fetchedBankAccounts[i].status = action.payload.status;
                }
                updatedBankAccount.push(fetchedBankAccounts[i]);
            }
            console.log('CHECK UPDATED', updatedBankAccount);
            return {
                ...state,
                activatingBankAccount: false,
                activatingBankAccountSuccess: true,
                activatingBankAccountMessage: action.message,
                fetchedBankAccounts: updatedBankAccount
            };
        }
        case actions.ACTIVATE_BANK_ACCOUNT_FAILED:
            return {
                ...state,
                activatingBankAccount: false,
                activatingBankAccountSuccess: false,
                activatingBankAccountMessage: action.message
            };
        case actions.RESET_ACTIVATE_BANK_ACCOUNT:
            return {
                ...state,
                activatingBankAccount: false,
                activatingBankAccountSuccess: false,
                activatingBankAccountMessage: null
            };

        case actions.DEACTIVATING_BANK_ACCOUNT:
            return {
                ...state,
                deactivatingBankAccount: true
            };
        case actions.DEACTIVATED_BANK_ACCOUNT: {
            const fetchedBankAccounts = state.fetchedBankAccounts;
            const updatedBankAccount = [];
            for (let i = 0; i < fetchedBankAccounts.length; i++) {
                const item = fetchedBankAccounts[i];
                if (action.payload._id === item._id) {
                    fetchedBankAccounts[i].status = action.payload.status;
                }
                updatedBankAccount.push(fetchedBankAccounts[i]);
            }
            return {
                ...state,
                deactivatingBankAccount: false,
                deactivatingBankAccountSuccess: true,
                deactivatingBankAccountMessage: action.message,
                fetchedBankAccounts: updatedBankAccount
            };
        }
        case actions.DEACTIVATE_BANK_ACCOUNT_FAILED:
            return {
                ...state,
                deactivatingBankAccount: false,
                deactivatingBankAccountSuccess: false,
                deactivatingBankAccountMessage: action.message
            };
        case actions.RESET_DEACTIVATE_BANK_ACCOUNT:
            return {
                ...state,
                deactivatingBankAccount: false,
                deactivatingBankAccountSuccess: false,
                deactivatingBankAccountMessage: null
            };

        default:
            return state;
    }
}